export type CanonicalizeErrorCode = 'UNSUPPORTED_TYPE' | 'NON_FINITE_NUMBER' | 'CIRCULAR_REFERENCE' | 'DUPLICATE_KEY'

export class CanonicalizeError extends Error {
  override readonly name = 'CanonicalizeError'
  readonly code: CanonicalizeErrorCode
  readonly path: readonly string[]

  constructor(code: CanonicalizeErrorCode, message: string, path: readonly string[]) {
    super(message)
    this.code = code
    this.path = path
  }
}
